import { Paper, Stack } from '@mui/material';
import { MHMTextField } from '../MHM/MHMTextField';
import { MHMButton } from '../MHM/MHMButton';
import { useTranslation } from '../../../contexts/TranslationContext';
import { useSetRecoilState } from 'recoil';
import {
  accountSearchTextAtom,
  newAccountModalAtom,
} from '../../../models/atoms/account_atoms';
import { useIsMobile } from '../../../hooks/useIsMobile';

export function AccountSearch() {
  const { t } = useTranslation();
  const setSearchText = useSetRecoilState(accountSearchTextAtom);
  const setAccountModalOpen = useSetRecoilState(newAccountModalAtom);
  const isMobile = useIsMobile();

  return (
    <Stack direction={isMobile ? 'column' : 'row'} gap={2}>
      <Paper sx={{ flex: 1 }}>
        <MHMTextField
          autoComplete="off"
          size="small"
          fullWidth
          placeholder={t('Search Accounts')}
          onChange={e => setSearchText(e.target.value)}
        />
      </Paper>
      <MHMButton size="medium" onClick={() => setAccountModalOpen(true)}>
        {t('Add New Account')}
      </MHMButton>
    </Stack>
  );
}
